<template>
  <div class="checkbox product-compare pull-left">
    <label>
      <input 
        :data-style="masterStyle"
        type="checkbox" 
        @change="onProductCompareChange">
      <span class="compare-add">Compare</span>
      <a 
        class="compare-now" 
        href=""
        style="display:none;">Compare Now</a>
    </label>
  </div>
</template>

<style scoped>
</style>

<script>
import { productCompare } from '../../module/util'

export default {
    props: {
        masterStyle: {
            type: String,
            default: null
        }
    },

    methods: {
        onProductCompareChange () {
            productCompare()
        },
    }
}
</script>
